import { render } from "./QHLSExamRegistrationPublic.vue?vue&type=template&id=73f507b8&scoped=true"
import script from "./QHLSExamRegistrationPublic.vue?vue&type=script&lang=js"
export * from "./QHLSExamRegistrationPublic.vue?vue&type=script&lang=js"

import "./QHLSExamRegistrationPublic.vue?vue&type=style&index=0&id=73f507b8&scoped=true&lang=css"
import "./QHLSExamRegistrationPublic.vue?vue&type=style&index=1&id=73f507b8&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73f507b8"]])

export default __exports__